import { useEffect } from 'react';
import { logger } from '../utils/logger';
import { getEnvironment } from '../constants/environment';

const GA_MEASUREMENT_ID = 'G-LHREJH14QH';

export function GoogleAnalytics() {
  useEffect(() => {
    // 本番環境（ichigen-cho.com）以外ではGoogle Analyticsを読み込まない
    const env = getEnvironment();
    if (env !== 'production') {
      logger.info(`[GoogleAnalytics] Skipped in ${env} environment`);
      return;
    }

    // 本番環境のみGoogle Analyticsを有効化
    logger.info('[GoogleAnalytics] Loading Google Analytics...');

    // gtag.jsスクリプトを追加
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // dataLayerとgtag関数を初期化
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function gtag(...gtagArgs: any[]) {
      window.dataLayer.push(gtagArgs);
    }
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);

    // グローバルにgtagを設定
    window.gtag = gtag;

    logger.info('[GoogleAnalytics] Loaded successfully');

    // クリーンアップ
    return () => {
      // スクリプトタグを削除
      const scripts = document.querySelectorAll(`script[src*="googletagmanager.com"]`);
      scripts.forEach((s) => s.remove());
    };
  }, []);

  return null;
}

// TypeScript型定義
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag?: (...args: any[]) => void;
  }
}
